
<template>
  <div
    class="box-border flex flex-col w-full h-full p-8 overflow-hidden transition duration-300 ease-in-out border-red-500"
    :class="{ 'border-8 animate-pulse ': newSos }"
  >
    <!-- Page header -->
    <div class="flex items-center gap-3 mb-4">
      <span class="flex items-center justify-center w-10 h-10 rounded-xl bg-taxiye-100 text-taxiye-500">
        <span class="material-icons-round">announcement</span>
      </span>
      <div>
        <h2 class="text-lg font-semibold text-gray-800">SOS</h2>
        <p class="text-sm text-gray-500">Monitor active SOS alerts.</p>
      </div>
    </div>
    <div class="relative flex-1 w-full min-h-0 overflow-hidden rounded-lg shadow">
      <MapBoxWithMarkers
        :markers="markers"
        :mapCenter="mapCenter"
        :mapZoom="mapZoom"
        :popupData="popupData"
        @markerClicked="markerClicked"
      ></MapBoxWithMarkers>
    </div>
  </div>
</template>

<script>
import MapBoxWithMarkers from "@/components/MapBoxWithMarkers";

export default {
  data() {
    return {
      sosList: [],
      markers: [],
      mapCenter: {},
      mapZoom: null,
      newSos: null,
      currentSos: null,
    };
  },
  components: {
    MapBoxWithMarkers,
  },
  created() {
    this.getSosList();

    this.$sosSocket.on("sos", () => {
      this.newSos = true;
      setTimeout(() => (this.newSos = false), 6000);

      this.getSosList();
    });
  },
  computed: {
    popupData() {
      if (!this.currentSos)
        return '<p class="p-2 text-sm text-gray-500">Loading data... please wait...</p>';

      const element = this.currentSos;
      const driver = element.driver || {};
      const fullName =
        [driver.firstName, driver.lastName].filter(Boolean).join(" ") || "-";
      const happenedAt = element.createdAt
        ? new Date(element.createdAt).toLocaleString()
        : "-";

      const row = (icon, label, value) =>
        '<div class="flex items-start py-1.5 space-x-2">' +
        '<i class="text-base text-gray-400 material-icons-round">' + icon + "</i>" +
        '<div class="min-w-0">' +
        '<p class="text-xs font-medium tracking-wide text-gray-400 uppercase">' + label + "</p>" +
        '<p class="text-sm font-medium text-gray-800 break-words">' + value + "</p>" +
        "</div>" +
        "</div>";

      let content =
        '<div class="w-52 p-1">' +
        // Header
        '<div class="flex items-center pb-2 mb-1 space-x-3 border-b border-gray-100">' +
        '<span class="flex items-center justify-center flex-shrink-0 w-9 h-9 text-white bg-red-500 rounded-full material-icons-round">warning</span>' +
        '<div class="min-w-0">' +
        '<p class="text-sm font-bold text-gray-900 truncate">' + fullName + "</p>" +
        '<p class="text-xs font-semibold tracking-wide text-red-500 uppercase">SOS &middot; ' +
        (element.type || "alert") +
        "</p>" +
        "</div>" +
        "</div>" +
        // Details
        row("schedule", "Happened at", happenedAt) +
        row("directions_car", "Vehicle model", element.modelName || "-") +
        row("palette", "Vehicle color", element.color || "-") +
        row("tag", "Vehicle ID", element._id);

      if (element.trip) {
        content +=
          '<a href="/rides/' +
          element.trip +
          '/show" target="_blank" class="flex items-center justify-center w-full py-2 mt-2 text-sm font-semibold text-white rounded-lg shadow bg-taxiye-600 hover:bg-taxiye-500">' +
          "View trip details" +
          "</a>";
      }

      content += "</div>";
      return content;
    },
  },
  methods: {
    markerClicked(id) {
      this.currentSos = this.sosList.find((x) => x._id === id) || null;
    },
    getSosList() {
      this.$http
        .get(`/sos?populate=["driver","passenger","vehicle"]`)
        .then((response) => {
          this.sosList = response.data.data;
          this.updateMarkers(this.sosList);
        })
        .catch((err) => console.log(err));
    },
    updateMarkers(data) {
      this.markers = data
        .filter((element) => element.position && element.position.coordinates)
        .map((element) => {
          const driver = element.driver || {};
          return {
            id: element._id,
            type: "sos",
            coordinates: [
              element.position.coordinates[0],
              element.position.coordinates[1],
            ],
            color: "red",
            title: driver.firstName ? driver.firstName : "-",
          };
        });
    },
  },
};
</script>
